export const orderStatuses = () => [
  { value: 'incomplete', color: '#3C3B3B', backgroundColor: '#FFD4A2CC' },
  { value: 'complete', color: '#3C3B3B', backgroundColor: '#AAFFB2CC' },
  { value: 'planified', color: '#3C3B3B', backgroundColor: '#ADBAFFCC' },
  { value: 'done', color: '#3C3B3B', backgroundColor: '#AAFAFFCC' },
  { value: 'canceled', color: '#3C3B3B', backgroundColor: '#FFADADCC' },
]
export const deliveryOrderStatuses = () => [
  { value: 'incomplete', color: '#3C3B3B', backgroundColor: '#FFD4A2CC' },
  { value: 'planified', color: '#3C3B3B', backgroundColor: '#ADBAFFCC' },
  { value: 'complete', color: '#3C3B3B', backgroundColor: '#AAFFB2CC' },
  { value: 'valid', color: '#3C3B3B', backgroundColor: '#AAFAFFCC' },
  { value: 'canceled', color: '#3C3B3B', backgroundColor: '#FFADADCC' },
]
